import { type FC } from "react";

import { Card, CardContent } from "@/shared/components/ui/card";
import { Button } from "@/shared/components/ui/button";

import { ASSET_SEARCH_OPTIONS } from "@/pages/lawyer/client-detail/assetSearchOptions";

interface AssetSearchShortcutsProps {
  onViewAssetSearch: () => void;
}

export const AssetSearchShortcuts: FC<AssetSearchShortcutsProps> = ({ onViewAssetSearch }) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="text-lg font-semibold text-primary mb-1">Asset Searches</h3>
        <p className="text-sm text-secondary mb-4">
          Kick off a third-party search to surface accounts, property, and more.
        </p>
        <div className="space-y-2">
          {ASSET_SEARCH_OPTIONS.map((opt) => {
            const Icon = opt.icon;
            return (
              <div key={opt.id} className="flex items-center gap-3">
                <div
                  className={`w-8 h-8 rounded-md ${opt.iconBg} flex items-center justify-center flex-shrink-0`}
                >
                  <Icon className={`w-4 h-4 ${opt.iconColor}`} aria-hidden />
                </div>
                <span className="text-sm text-primary truncate">{opt.label}</span>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-4">
          <Button
            variant="link"
            size="sm"
            onClick={onViewAssetSearch}
            className="text-brand text-sm"
          >
            Start comprehensive asset search →
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
